import { useState } from "react";
import "./Price.css";
import calculator from "../../../image/calculator-icon.svg";

import returnMoney from "../../../image/refund-icon.svg";

function Price({ isUnit }) {
  const totalPrice = isUnit.reduce((sum, unit) => sum + unit.price, 0);
  const totalDuration = isUnit.reduce((sum, unit) => sum + unit.duration, 0);

  const [openUnitId, setOpenUnitId] = useState(null);

  const toggleUnit = (id) => {
    setOpenUnitId(openUnitId === id ? null : id);
  };

  return (
    <section className="price" id="price">
      <div className="price-container">
        <h2 className="skills__title skills__title_price">
          Стоимость обучения
        </h2>

        {/* Три преимущества (оставляем как есть) */}
        <ul className="price-container__list">
          <li className="price-container__condition">
            <img className="price-container__img" src={calculator} alt="иконка" />
            <p className="price-container__description">
              Весь курс разбит на&nbsp;несколько блоков. Оплата поэтапная
              вы&nbsp;платите только за&nbsp;тот блок, который сейчас проходите.
            </p>
          </li>
        
          <li className="price-container__condition">
            <img className="price-container__img" src={returnMoney} alt="иконка" />
            <p className="price-container__description">
              Если передумаете учиться, то&nbsp;возврат можно оформить
              в&nbsp;любой момент. Возвращаем деньги за&nbsp;3&nbsp;рабочих дня.
            </p>
          </li>
        </ul>

        {/* Таблица для десктопа и планшетов */}
        <div className="table-responsi table-desktop">
          <table className="table">
            <thead>
              <tr className="table__string">
                <th className="table__сell table__сell_heading">Блок</th>
                <th className="table__сell table__сell_heading table__сell_price table__сell_alignments">
                  Стоимость&nbsp;(₽)&nbsp;**
                </th>
                <th className="table__сell table__сell_heading table__сell_alignments">
                  Расчетное&nbsp;время&nbsp;обучения&nbsp;(мес.)&nbsp;*
                </th>
              </tr>
            </thead>
            <tbody>
              {isUnit.map((unit, index) => (
                <tr
                  key={unit._id}
                  className={`table__string ${
                    index % 2 === 0 ? "table__string_dark" : ""
                  }`}
                >
                  <td className="table__сell">{unit.title}</td>
                  <td className="table__сell table__сell_price table__сell_alignments">
                    {unit.price.toLocaleString()}
                  </td>
                  <td className="table__сell table__сell_alignments">
                    {unit.duration}
                  </td>
                </tr>
              ))}
              <tr className="table__string">
                <td className="table__сell table__сell_total">Итого</td>
                <td className="table__сell table__сell_total table__сell_price table__сell_alignments">
                  {totalPrice.toLocaleString()}***
                </td>
                <td className="table__сell table__сell_total table__сell_alignments">
                  {totalDuration}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Мобильный аккордеон (только на узких экранах) */}
        <div className="price-accordion">
       

          <div className="price-accordion__list">
            {isUnit.map((unit) => (
              <div key={unit._id} className="price-accordion__item">
                <button
                  className={`price-accordion__header ${
                    openUnitId === unit._id ? "price-accordion__header_open" : ""
                  }`}
                  onClick={() => toggleUnit(unit._id)}
                  aria-expanded={openUnitId === unit._id}
                >
                  <span className="price-accordion__title">{unit.title}</span>
                  <span className="price-accordion__price">
                    {unit.price.toLocaleString()} ₽
                  </span>
                  <span className="price-accordion__icon">
                    {openUnitId === unit._id ? "−" : "+"}
                  </span>
                </button>
                <div
                  className={`price-accordion__content ${
                    openUnitId === unit._id ? "price-accordion__content_open" : ""
                  }`}
                >
                  <div className="price-accordion__duration">
                    ⏱ Расчетное время обучения: {unit.duration} мес. *
                  </div>
                </div>
              </div>
            ))}
          </div>
             <div className="price-accordion__total">
            <div className="price-accordion__total-label">Общая стоимость курса</div>
            <div className="price-accordion__total-price">
              {totalPrice.toLocaleString()} <span className="price-accordion__total-currency">₽</span>
              <span className="price-accordion__total-footnote">***</span>
            </div>
            <div className="price-accordion__total-duration">
              Общее время: {totalDuration} мес.
            </div>
          </div>
        </div>

        {/* Примечания */}
        <div className="table-note">
          <ul className="table-note-list">
            <li className="table-note-list__item">
              <span className="table-note__mark">*</span>
              если занятиям уделяется не менее 10 часов в неделю
            </li>
            <li className="table-note-list__item">
              <span className="table-note__mark">**</span>
              В стоимость входит доступ к лицензионной системе БАЗИС на время обучения.
            </li>
            <li className="table-note-list__item">
              <span className="table-note__mark">***</span>
              Если у вас уже есть лицензия БАЗИС и вам не нужен наш доступ на время обучения,
              напишите нам — уменьшим стоимость.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Price;